import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { LINKS } from "@/lib/site";

const StickyJoinButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 420);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
          className="fixed inset-x-4 bottom-4 z-40 md:hidden"
        >
          <a
            href={LINKS.community}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="sticky-join-button"
            className="flex items-center justify-center gap-2.5 rounded-2xl bg-whatsapp py-4 text-sm font-bold text-white shadow-[0_16px_40px_-8px_rgba(37,211,102,0.6)] transition-colors duration-200 hover:bg-whatsapp-dark"
          >
            <MessageCircle size={19} strokeWidth={2.2} />
            Join JGW on WhatsApp
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyJoinButton;
